[
    {
        "ID": 101,
        "NAME": "FIAT",
        "DESCRIPTION": "FIAT",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 102,
        "NAME": "Alfa Romeo",
        "DESCRIPTION": "Alfa Romeo",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 103,
        "NAME": "RAM",
        "DESCRIPTION": "RAM",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 104,
        "NAME": "Dodge",
        "DESCRIPTION": "Dodge",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 105,
        "NAME": "Chrysler",
        "DESCRIPTION": "Chrysler",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 106,
        "NAME": "Jeep",
        "DESCRIPTION": "Jeep",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 107,
        "NAME": "500L",
        "DESCRIPTION": "500L",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 108,
        "NAME": "500X",
        "DESCRIPTION": "500X",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 109,
        "NAME": "Fiat 500 Electric",
        "DESCRIPTION": "Fiat 500 Electric",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 110,
        "NAME": "500 Pro BEV",
        "DESCRIPTION": "500 Pro BEV",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 111,
        "NAME": "Ducato",
        "DESCRIPTION": "Ducato",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 112,
        "NAME": "Giulia",
        "DESCRIPTION": "Giulia",
        "PARENT_ID": 102,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 113,
        "NAME": "Stelvio",
        "DESCRIPTION": "Stelvio",
        "PARENT_ID": 102,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 114,
        "NAME": "PHEV Tonale",
        "DESCRIPTION": "PHEV Tonale",
        "PARENT_ID": 102,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 115,
        "NAME": "Tonale",
        "DESCRIPTION": "Tonale",
        "PARENT_ID": 102,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 116,
        "NAME": "ProMaster",
        "DESCRIPTION": "ProMaster",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 117,
        "NAME": "Promaster City",
        "DESCRIPTION": "Promaster City",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 118,
        "NAME": "Heavy Duty",
        "DESCRIPTION": "Heavy Duty",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 119,
        "NAME": "Light Duty",
        "DESCRIPTION": "Light Duty",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 120,
        "NAME": "Ram",
        "DESCRIPTION": "Ram",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 121,
        "NAME": "Durango",
        "DESCRIPTION": "Durango",
        "PARENT_ID": 104,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 122,
        "NAME": "Hornet",
        "DESCRIPTION": "Hornet",
        "PARENT_ID": 104,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 123,
        "NAME": "Pacifica",
        "DESCRIPTION": "Pacifica",
        "PARENT_ID": 105,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 124,
        "NAME": "Voyager",
        "DESCRIPTION": "Voyager",
        "PARENT_ID": 105,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 125,
        "NAME": "Pacifica PHEV",
        "DESCRIPTION": "Pacifica PHEV",
        "PARENT_ID": 105,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 126,
        "NAME": "Grand Cherokee",
        "DESCRIPTION": "Grand Cherokee",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 127,
        "NAME": "Wagoneer",
        "DESCRIPTION": "Wagoneer",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 128,
        "NAME": "Grand Wagoneer",
        "DESCRIPTION": "Grand Wagoneer",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 129,
        "NAME": "Compass",
        "DESCRIPTION": "Compass",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 130,
        "NAME": "Grand Cherokee PHEV",
        "DESCRIPTION": "Grand Cherokee PHEV",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 131,
        "NAME": "Wrangler",
        "DESCRIPTION": "Wrangler",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 132,
        "NAME": "Gladiator",
        "DESCRIPTION": "Gladiator",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 133,
        "NAME": "Commander",
        "DESCRIPTION": "Commander",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 134,
        "NAME": "Compass PHEV",
        "DESCRIPTION": "Compass PHEV",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 135,
        "NAME": "U CONNECT NAVIGATION",
        "DESCRIPTION": "U CONNECT NAVIGATION",
        "PARENT_ID": 107,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 136,
        "NAME": "U CONNECT NAVIGATION",
        "DESCRIPTION": "U CONNECT NAVIGATION",
        "PARENT_ID": 108,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 137,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 109,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 138,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 110,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 139,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 111,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 140,
        "NAME": "CONNECT NAV",
        "DESCRIPTION": "CONNECT NAV",
        "PARENT_ID": 112,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 141,
        "NAME": "3D CONNECT NAV",
        "DESCRIPTION": "3D CONNECT NAV",
        "PARENT_ID": 112,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 142,
        "NAME": "3D CONNECT NAV MY20",
        "DESCRIPTION": "3D CONNECT NAV MY20",
        "PARENT_ID": 112,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 143,
        "NAME": "CONNECT NAV",
        "DESCRIPTION": "CONNECT NAV",
        "PARENT_ID": 113,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 144,
        "NAME": "3D CONNECT NAV",
        "DESCRIPTION": "3D CONNECT NAV",
        "PARENT_ID": 113,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 145,
        "NAME": "3D CONNECT NAV MY20",
        "DESCRIPTION": "3D CONNECT NAV MY20",
        "PARENT_ID": 113,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 146,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 114,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 147,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 115,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 148,
        "NAME": "U CONNECT 3 NAV",
        "DESCRIPTION": "U CONNECT 3 NAV",
        "PARENT_ID": 116,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 149,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 116,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 150,
        "NAME": "U CONNECT 3 NAV",
        "DESCRIPTION": "U CONNECT 3 NAV",
        "PARENT_ID": 117,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 151,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 118,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 152,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 119,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 153,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 120,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 154,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 121,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 155,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 122,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 156,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 123,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 157,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 124,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 158,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 125,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 159,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 126,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 160,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 127,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 161,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 128,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 162,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 129,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 163,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 130,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 164,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 131,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 165,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 132,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 166,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 133,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 167,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 134,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 168,
        "NAME": "New Doblò",
        "DESCRIPTION": "New Doblò",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 169,
        "NAME": "Scudo",
        "DESCRIPTION": "Scudo",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 170,
        "NAME": "8\" Radio With NAV",
        "DESCRIPTION": "8\" Radio With NAV",
        "PARENT_ID": 168,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 171,
        "NAME": "7\" Radio With NAV",
        "DESCRIPTION": "7\" Radio With NAV",
        "PARENT_ID": 169,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 172,
        "NAME": "Maserati",
        "DESCRIPTION": "Maserati",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 101
    },
    {
        "ID": 173,
        "NAME": "Ghibli",
        "DESCRIPTION": "Ghibli",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 174,
        "NAME": "Levante",
        "DESCRIPTION": "Levante",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 175,
        "NAME": "Quattroporte",
        "DESCRIPTION": "Quattroporte",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 176,
        "NAME": "Grecale",
        "DESCRIPTION": "Grecale",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 177,
        "NAME": "Granturismo/Grancabrio",
        "DESCRIPTION": "Granturismo/Grancabrio",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 178,
        "NAME": "MC20",
        "DESCRIPTION": "MC20",
        "PARENT_ID": 172,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 179,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 173,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 180,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 174,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 181,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 175,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 182,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 176,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 183,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 177,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 184,
        "NAME": "MTC+ MY21~",
        "DESCRIPTION": "MTC+ MY21~",
        "PARENT_ID": 178,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 185,
        "NAME": "Fastback",
        "DESCRIPTION": "Fastback",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 186,
        "NAME": "Pulse",
        "DESCRIPTION": "Pulse",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 187,
        "NAME": "Toro",
        "DESCRIPTION": "Toro",
        "PARENT_ID": 101,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
	{
        "ID": 188,
        "NAME": "Uconnect Nav 8.4\"",
        "DESCRIPTION": "Uconnect Nav 8.4\"",
        "PARENT_ID": 185,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 189,
        "NAME": "Uconnect Nav 8.4\"",
        "DESCRIPTION": "Uconnect Nav 8.4\"",
        "PARENT_ID": 186,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 190,
        "NAME": "Uconnect Nav 8.4\"",
        "DESCRIPTION": "Uconnect Nav 8.4\"",
        "PARENT_ID": 187,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 191,
        "NAME": "Renegade",
        "DESCRIPTION": "Renegade",
        "PARENT_ID": 106,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 192,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 191,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 193,
        "NAME": "Rampage",
        "DESCRIPTION": "Rampage",
        "PARENT_ID": 103,
        "VEHICLE_MODEL_TYPE_ID": 102
    },
    {
        "ID": 194,
        "NAME": "Uconnect 5 NAV",
        "DESCRIPTION": "Uconnect 5 NAV",
        "PARENT_ID": 193,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 195,
        "NAME": "Uconnect Nav 10\"",
        "DESCRIPTION": "Uconnect Nav 10\"",
        "PARENT_ID": 185,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 196,
        "NAME": "Uconnect Nav 10\"",
        "DESCRIPTION": "Uconnect Nav 10\"",
        "PARENT_ID": 186,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 197,
        "NAME": "Uconnect Nav 10\"",
        "DESCRIPTION": "Uconnect Nav 10\"",
        "PARENT_ID": 187,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 198,
        "NAME": "Uconnect Nav 8.4\"",
        "DESCRIPTION": "Uconnect Nav 8.4\"",
        "PARENT_ID": 129,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 199,
        "NAME": "Uconnect Nav 10\"",
        "DESCRIPTION": "Uconnect Nav 10\"",
        "PARENT_ID": 129,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 1001,
        "NAME": "Uconnect Nav 10\"",
        "DESCRIPTION": "Uconnect Nav 10\"",
        "PARENT_ID": 133,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
	{
        "ID": 1002,
        "NAME": "Uconnect Nav 8.4\"",
        "DESCRIPTION": "Uconnect Nav 8.4\"",
        "PARENT_ID": 191,
        "VEHICLE_MODEL_TYPE_ID": 103
    },
    {
        "ID": 201,
        "NAME": "Tivoli",
        "DESCRIPTION": "Tivoli",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 202,
        "NAME": "Korando",
        "DESCRIPTION": "Korando",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 203,
        "NAME": "Rexton",
        "DESCRIPTION": "Rexton",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 204,
        "NAME": "MUSSO/REXTON SPORTS",
        "DESCRIPTION": "MUSSO/REXTON SPORTS",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 205,
        "NAME": "ALTURAS G4 (INDIA)",
        "DESCRIPTION": "ALTURAS G4 (INDIA)",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 210,
        "NAME": "X115",
        "DESCRIPTION": "X115",
        "PARENT_ID": 201,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 211,
        "NAME": "X150",
        "DESCRIPTION": "X150",
        "PARENT_ID": 201,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 213,
        "NAME": "C300",
        "DESCRIPTION": "C300",
        "PARENT_ID": 202,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 214,
        "NAME": "Y400",
        "DESCRIPTION": "Y400",
        "PARENT_ID": 203,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 215,
        "NAME": "Q200",
        "DESCRIPTION": "Q200",
        "PARENT_ID": 204,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 216,
        "NAME": "Q250",
        "DESCRIPTION": "Q250",
        "PARENT_ID": 204,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 217,
        "NAME": "Y400 (INDIA)",
        "DESCRIPTION": "Y400 (INDIA)",
        "PARENT_ID": 205,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 218,
        "NAME": "E100",
        "DESCRIPTION": "E100",
        "PARENT_ID": 202,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 219,
        "NAME": "Y450",
        "DESCRIPTION": "Y450",
        "PARENT_ID": 203,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 220,
        "NAME": "2015",
        "DESCRIPTION": "2015",
        "PARENT_ID": 208,
        "VEHICLE_MODEL_TYPE_ID": 203
    },
    {
        "ID": 221,
        "NAME": "2016",
        "DESCRIPTION": "2016",
        "PARENT_ID": 209,
        "VEHICLE_MODEL_TYPE_ID": 203
    },
    {
        "ID": 222,
        "NAME": "2015",
        "DESCRIPTION": "2015",
        "PARENT_ID": 212,
        "VEHICLE_MODEL_TYPE_ID": 203
    },
    {
        "ID": 223,
        "NAME": "TORRES",
        "DESCRIPTION": "TORRES",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 224,
        "NAME": "J101",
        "DESCRIPTION": "J101",
        "PARENT_ID": 223,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 225,
        "NAME": "Y461",
        "DESCRIPTION": "Y461",
        "PARENT_ID": 203,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 226,
        "NAME": "Q261",
        "DESCRIPTION": "Q261",
        "PARENT_ID": 204,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 228,
        "NAME": "X170",
        "DESCRIPTION": "X170",
        "PARENT_ID": 201,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 230,
        "NAME": "U100",
        "DESCRIPTION": "U100",
        "PARENT_ID": 229,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 231,
        "NAME": "Y470",
        "DESCRIPTION": "Y470",
        "PARENT_ID": 203,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 232,
        "NAME": "Q270",
        "DESCRIPTION": "Q270",
        "PARENT_ID": 204,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 233,
        "NAME": "J116",
        "DESCRIPTION": "J116",
        "PARENT_ID": 223,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 234,
        "NAME": "C330",
        "DESCRIPTION": "C330",
        "PARENT_ID": 202,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 235,
        "NAME": "X180",
        "DESCRIPTION": "X180",
        "PARENT_ID": 201,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 236,
        "NAME": "TORRES EV",
        "DESCRIPTION": "TORRES EV",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 237,
        "NAME": "U100",
        "DESCRIPTION": "U100",
        "PARENT_ID": 236,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 238,
        "NAME": "Actyon",
        "DESCRIPTION": "Actyon",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
    {
        "ID": 239,
        "NAME": "J120",
        "DESCRIPTION": "J120",
        "PARENT_ID": 238,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 240,
        "NAME": "J110",
        "DESCRIPTION": "J110",
        "PARENT_ID": 223,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 241,
        "NAME": "TORRES Hybrid",
        "DESCRIPTION": "TORRES Hybrid",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
	{
        "ID": 242,
        "NAME": "Actyon Hybrid",
        "DESCRIPTION": "Actyon Hybrid",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
	{
        "ID": 243,
        "NAME": "MUSSO EV",
        "DESCRIPTION": "MUSSO EV",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 201
    },
	{
        "ID": 244,
        "NAME": "J140",
        "DESCRIPTION": "J140",
        "PARENT_ID": 241,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 245,
        "NAME": "J145",
        "DESCRIPTION": "J145",
        "PARENT_ID": 242,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 246,
        "NAME": "O100",
        "DESCRIPTION": "O100",
        "PARENT_ID": 243,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 247,
        "NAME": "U105",
        "DESCRIPTION": "U105",
        "PARENT_ID": 236,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 248,
        "NAME": "J116 25MY",
        "DESCRIPTION": "J116 25MY",
        "PARENT_ID": 223,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
	{
        "ID": 249,
        "NAME": "Q300",
        "DESCRIPTION": "Q300",
        "PARENT_ID": 204,
        "VEHICLE_MODEL_TYPE_ID": 202
    },
    {
        "ID": 301,
        "NAME": "Daily NIS MY19",
        "DESCRIPTION": "Daily NIS MY19",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 301
    },
    {
        "ID": 302,
        "NAME": "Way range NIS MY19",
        "DESCRIPTION": "Way range NIS MY19",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 301
    },
    {
        "ID": 303,
        "NAME": "Daily IHP MY24",
        "DESCRIPTION": "Daily IHP MY24",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 301
    },
    {
        "ID": 304,
        "NAME": "Way range IHP MY24",
        "DESCRIPTION": "Way range IHP MY24",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 301
    },
    {
        "ID": 401,
        "NAME": "index.pajero_sport",
        "DESCRIPTION": "Pajero Sports",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 401
    },
    {
        "ID": 402,
        "NAME": "index.Rvr",
        "DESCRIPTION": "RVR",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 401
    },
    {
        "ID": 403,
        "NAME": "index.outlander",
        "DESCRIPTION": "Outlander",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 401
    },
    {
        "ID": 404,
        "NAME": "index.outlander_phv",
        "DESCRIPTION": "Outlander PHV",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 401
    },
    {
        "ID": 405,
        "NAME": "index.Eclipse_Cross",
        "DESCRIPTION": "Eclipse Cross",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 401
    },
    {
        "ID": 406,
        "NAME": "index.South_East_Asia",
        "DESCRIPTION": "South East Asia",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 407,
        "NAME": "index.Africa1",
        "DESCRIPTION": "Africa",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 408,
        "NAME": "index.Latin_America_except_Chile",
        "DESCRIPTION": "Latin America &rlm;(except Chile)",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 409,
        "NAME": "index.Latin_America_only_for_Chile",
        "DESCRIPTION": "Latin America &rlm;(only for Chile)",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 410,
        "NAME": "index.Russia1",
        "DESCRIPTION": "Russia",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 411,
        "NAME": "index.Russia1",
        "DESCRIPTION": "Russia",
        "PARENT_ID": 402,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 412,
        "NAME": "index.Russia1",
        "DESCRIPTION": "Russia",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 413,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "Europe &rlm;(except Russia)",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 414,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "Europe &rlm;(except Russia)",
        "PARENT_ID": 402,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 415,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "Europe &rlm;(except Russia)",
        "PARENT_ID": 403,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 416,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "Europe &rlm;(except Russia)",
        "PARENT_ID": 404,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 417,
        "NAME": "index.Israel",
        "DESCRIPTION": "Israel",
        "PARENT_ID": 403,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 418,
        "NAME": "index.Israel",
        "DESCRIPTION": "Israel",
        "PARENT_ID": 404,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 419,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "DESCRIPTION": "Middle East Asia &rlm;(except Israel)",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 420,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "DESCRIPTION": "Middle East Asia &rlm;(except Israel)",
        "PARENT_ID": 403,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 421,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "DESCRIPTION": "Middle East Asia &rlm;(except Israel)",
        "PARENT_ID": 404,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 422,
        "NAME": "index.Oceania",
        "DESCRIPTION": "Oceania",
        "PARENT_ID": 401,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 423,
        "NAME": "index.Oceania",
        "DESCRIPTION": "Oceania",
        "PARENT_ID": 402,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 424,
        "NAME": "index.Oceania",
        "DESCRIPTION": "Oceania",
        "PARENT_ID": 403,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 425,
        "NAME": "index.Oceania",
        "DESCRIPTION": "Oceania",
        "PARENT_ID": 404,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 426,
        "NAME": "index.Oceania",
        "DESCRIPTION": "Oceania",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 427,
        "NAME": "index.North_America",
        "DESCRIPTION": "North America",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 428,
        "NAME": "index.South_East_Asia",
        "DESCRIPTION": "South East Asia",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 429,
        "NAME": "index.Latin_America_except_Chile",
        "DESCRIPTION": "Latin America (except Chile)",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 430,
        "NAME": "index.Latin_America_only_for_Chile",
        "DESCRIPTION": "Latin America: (only for Chile)",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 431,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "Europe (except Russia)",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 432,
        "NAME": "index.Africa1",
        "DESCRIPTION": "Africa",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 433,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "DESCRIPTION": "Middle East Asia (except Israel)",
        "PARENT_ID": 405,
        "VEHICLE_MODEL_TYPE_ID": 402
    },
    {
        "ID": 501,
        "NAME": "Europe",
        "DESCRIPTION": "",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 501
    },
    {
        "ID": 502,
        "NAME": "153",
        "DESCRIPTION": "MS5900GLB161",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 503,
        "NAME": "161",
        "DESCRIPTION": "MS5900GLB161",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 504,
        "NAME": "163",
        "DESCRIPTION": "MS5900GLB163",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 505,
        "NAME": "171",
        "DESCRIPTION": "MS5900GLB171",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 506,
        "NAME": "173",
        "DESCRIPTION": "MS5900GLB173",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 507,
        "NAME": "181",
        "DESCRIPTION": "MS5900GLB181",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 508,
        "NAME": "183",
        "DESCRIPTION": "MS5900GLB183",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 509,
        "NAME": "191",
        "DESCRIPTION": "MS5900GLB191",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 510,
        "NAME": "201",
        "DESCRIPTION": "MS5900GLB201",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 511,
        "NAME": "203",
        "DESCRIPTION": "MS5900GLB203",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 512,
        "NAME": "211",
        "DESCRIPTION": "MS5900GLB211",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 513,
        "NAME": "213",
        "DESCRIPTION": "MS5900GLB213",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 514,
        "NAME": "221",
        "DESCRIPTION": "MS5900GLB221",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 515,
        "NAME": "223",
        "DESCRIPTION": "MS5900GLB223",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 516,
        "NAME": "231",
        "DESCRIPTION": "MS5900GLB231",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 517,
        "NAME": "233",
        "DESCRIPTION": "MS5900GLB233",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 518,
        "NAME": "241",
        "DESCRIPTION": "MS5900GLB241",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 519,
        "NAME": "243",
        "DESCRIPTION": "MS5900GLB243",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 520,
        "NAME": "251",
        "DESCRIPTION": "MS5900GLB251",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 521,
        "NAME": "253",
        "DESCRIPTION": "MS5900GLB253",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
	{
        "ID": 522,
        "NAME": "261",
        "DESCRIPTION": "MS5900GLB261",
        "PARENT_ID": 501,
        "VEHICLE_MODEL_TYPE_ID": 502
    },
    {
        "ID": 601,
        "NAME": "Movano",
        "DESCRIPTION": "Movano",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 601
    },
    {
        "ID": 602,
        "NAME": "Vivaro",
        "DESCRIPTION": "Vivaro",
        "PARENT_ID": 0,
        "VEHICLE_MODEL_TYPE_ID": 601
    },
    {
        "ID": 603,
        "NAME": "Navi 80 Intellilink",
        "DESCRIPTION": "Navi 80 Intellilink",
        "PARENT_ID": 601,
        "VEHICLE_MODEL_TYPE_ID": 602
    },
    {
        "ID": 604,
        "NAME": "Navi 80 Intellilink",
        "DESCRIPTION": "Navi 80 Intellilink",
        "PARENT_ID": 602,
        "VEHICLE_MODEL_TYPE_ID": 602
    }
]